const sevenDays =()=>{
    let days = {
        day1: "",
        day2: "",
        day3: "",
        day4: "",
        day5: "",
        day6: "",
        day7: "",
      };

      var today = new Date();
      var today1 = new Date();
      let tomorrow = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 1
      );
      let tomorrow1 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 1
      );
      let day3 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 2
      );
      let day31 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 2
      );
      let day4 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 3
      );
      let day41 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 3
      );
      let day5 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 4
      );
      let day51 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 4
      );
      let day6 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 5
      );
      let day61 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 5
      );
      let day7 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 6
      );
      let day71 = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 6
      );
      today = new Intl.DateTimeFormat("en-US", {
        month: "2-digit",
        day: "2-digit",
      }).format(today);
      today1 = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
      }).format(today1);
      tomorrow = new Intl.DateTimeFormat("en-US", {
        month: "2-digit",
        day: "2-digit",
      }).format(tomorrow);
      tomorrow1 = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
      }).format(tomorrow1);
      day3 = new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        weekday: "short",
      }).format(day3);
      day31 = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
      }).format(day31);
      day4 = new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        weekday: "short",
      }).format(day4);
      day41 = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
      }).format(day41);
      day5 = new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        weekday: "short",
      }).format(day5);
      day51 = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
      }).format(day51);
      day6 = new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        weekday: "short",
      }).format(day6);
      day61 = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
      }).format(day61);
      day7 = new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        weekday: "short",
      }).format(day7);
      day71 = new Intl.DateTimeFormat("en-US", {
        weekday: "short",
      }).format(day71);
      const setDate = ()=> {
        if (today1 === "Fri" || tomorrow1 === 'Fri' || day31==='Fri' || day41==='Fri' || day51==='Fri' || day61==='Fri' || day71==='Fri') {
          days.day1 = 1;
        }
        if (tomorrow1 === "Sat" || today1 === 'Sat' || day31 === 'Sat' || day41 === 'Sat' || day51 === 'Sat' || day61 === 'Sat' || day71 === 'Sat') {
          days.day2 = 2;
        }
        if (day31 === "Sun" || today1 === 'Sun' || tomorrow1 === 'Sun' || day41 === 'Sun' || day51 === 'Sun' || day61 === 'Sun' || day71 === 'Sun') {
          days.day3 = 3;
        }
        if (day41 === "Mon" || today1 === 'Mon' || tomorrow1 === 'Mon' || day31 === 'Mon' || day51 === 'Mon' || day61 === 'Mon' || day71 === 'Mon') {
          days.day4 = 4;
        }
        if (day51 === "Tue" || today1 === 'Tue' || tomorrow1 === 'Tue' || day31 === 'Tue' || day41 === 'Tue' || day61 === 'Tue' || day71 === 'Tue') {
          days.day5 = 5;
        }
        if (day61 === "Wed" || today1 === 'Wed' || tomorrow1 === 'Wed' || day31 === 'Wed' || day41 === 'Wed' || day51 === 'Wed' || day71 === 'Wed') {
          days.day6 = 6;
        }
        if (day71 === "Thu" || today1 === 'Thu' || tomorrow1 === 'Thu' || day31 === 'Thu' || day41 === 'Thu' || day51 === 'Thu' || day61 === 'Thu') {
          days.day7 = 7;
        }
      }
      setDate();

      return [today,tomorrow,day3,day4,day5,day6,day7];

}

const getPastHistoryDates=()=>{
  const dateArr=[];
  var date = new Date();
  dateArr.push({
    name: 'This Month',
    value: new Date(date.getFullYear(), date.getMonth()-0 , 1).toLocaleDateString("sv-SE"),
    end: new Date().toLocaleDateString("sv-SE"),
  });
  dateArr.push({
    name: 'Last Month',
    value: new Date(date.getFullYear(), date.getMonth()-1 , 1).toLocaleDateString("sv-SE"),
    end: new Date().toLocaleDateString("sv-SE"),
  });
  dateArr.push({
    name: 'Last Three Month',
    value: new Date(date.getFullYear(), date.getMonth()-2 , 1).toLocaleDateString("sv-SE"),
    end: new Date().toLocaleDateString("sv-SE"),
  });
  dateArr.push({
    name: 'Last Six Month',
    value: new Date(date.getFullYear(), date.getMonth()-5 , 1).toLocaleDateString("sv-SE"),
    end: new Date().toLocaleDateString("sv-SE"),
  });
  dateArr.push({
    name: 'Last Year',
    value: new Date(date.getFullYear(), date.getMonth()-11 , 1).toLocaleDateString("sv-SE"),
    end: new Date().toLocaleDateString("sv-SE"),
  });
  for (var i=1; i<=3; i++) {
    dateArr.push({
      name: date.getFullYear()-i,
      value: new Date(date.getFullYear()-i, 0 , 1).toLocaleDateString("sv-SE"),
      end: new Date(date.getFullYear()-i, 11 , 31).toLocaleDateString("sv-SE"),
    });
  }

  return dateArr;
}

const formattedDayString = (day) => {
  const days = sevenDays();
  let dayName = "";
  if (day === 0) {
    dayName = "Today";
  } else if (day === 1) {
    dayName = "Tomorrow";
  }
  return dayName +" "+ days[day];
};

export  {sevenDays,getPastHistoryDates,formattedDayString};